import React, { useState, useEffect } from 'react';
import logoSvg from '../assets/logo.svg';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Header = () => {
  const [menuActive, setMenuActive] = useState(false);
  const [activeLink, setActiveLink] = useState('home');
  const { currentUser, logout } = useAuth();

  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll('section[id]');
      let current = '';
      
      sections.forEach(section => {
        const sectionTop = section.offsetTop - 100;
        const sectionHeight = section.offsetHeight;
        
        if (window.pageYOffset >= sectionTop && window.pageYOffset < sectionTop + sectionHeight) {
          current = section.getAttribute('id');
        }
      });
      
      if (current) {
        setActiveLink(current);
      }
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setMenuActive(!menuActive);
  };

  const handleNavLinkClick = (id) => {
    setActiveLink(id);
    setMenuActive(false);
    
    // Smooth scroll to section
    const targetElement = document.getElementById(id);
    if (targetElement) {
      const headerHeight = document.querySelector('header').offsetHeight;
      const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - headerHeight;
      
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <header>
      <div className="container">
        <div className="logo">
          <Link to="/">Kinfhertix</Link>
        </div>
        <nav className={menuActive ? 'active' : ''}>
          <ul>
            <li>
              <Link 
                to="/" 
                className={activeLink === 'home' ? 'active' : ''}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavLinkClick('home');
                }}
              >
                Ana Sayfa
              </Link>
            </li>
            <li>
              <Link 
                to="/services" 
                className={activeLink === 'expertise' ? 'active' : ''}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavLinkClick('expertise');
                }}
              >
                Hizmetler
              </Link>
            </li>
            <li>
              <Link 
                to="/about" 
                className={activeLink === 'about' ? 'active' : ''}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavLinkClick('about');
                }}
              >
                Hakkımızda
              </Link>
            </li>
            <li>
              <Link 
                to="/solutions" 
                className={activeLink === 'projects' ? 'active' : ''}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavLinkClick('projects');
                }}
              >
                Ürünler
              </Link>
            </li>
            <li>
              <Link 
                to="/references" 
                className={activeLink === 'references' ? 'active' : ''}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavLinkClick('references');
                }}
              >
                Referanslar
              </Link>
            </li>
          </ul>
        </nav>
        <div 
          className={`menu-toggle ${menuActive ? 'active' : ''}`}
          onClick={toggleMenu}
        >
          <i className={`fas ${menuActive ? 'fa-times' : 'fa-bars'}`}></i>
        </div>
        <div className="auth-buttons">
          {currentUser ? (
            <>
              <Link to="/profile" className="profile-link">
                <img 
                  src={`https://cdn.discordapp.com/avatars/${currentUser.id}/${currentUser.avatar}.png`} 
                  alt="Profile" 
                  className="profile-avatar-small"
                />
                <span>{currentUser.username}</span>
              </Link>
              <button onClick={logout} className="logout-button">
                Çıkış Yap
              </button>
            </>
          ) : (
            <Link to="/auth/login" className="login-button">
              Giriş Yap
            </Link>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header; 